import { Button } from '../../shadcn';
import Logo from '@/assets/logo.svg';

export const ErrorFallback = ({ error, resetErrorBoundary }) => {
  return (
    <div className="h-screen w-screen flex flex-col items-center justify-center gap-4 px-5">
      <img src={Logo} alt="Bfit-log" className="w-60 h-30" />
      <div className="flex flex-col gap-3">
        <h2 className="text-[#141414] text-[28px] font-bold leading-tight text-center">
          Oops! Something went wrong.
        </h2>
        <p className="text-[#141414] text-base font-normal leading-normal text-center">
          {error.message}
        </p>
      </div>
      <Button size="lg" className="mt-5" onClick={resetErrorBoundary}>
        Try Again
      </Button>
    </div>
  );
};
